import { URL_LABEL } from "../../../index.content";
import { ADDITIONAL_LANGUAGES_BLOG } from "../../../../../../helpers/constants";

const blog = ({ language, isSavedUser }) => ({
  title: "Blog",
  target: false,
  ref: false,
  isLink: false,
  url: `${ADDITIONAL_LANGUAGES_BLOG.includes(language) ? `/${language}` : ""}/blog?${URL_LABEL}`,
});

export default blog;
